import {useMemo} from 'react';
import {useSelector} from 'react-redux';

/**
 * Платформенный контекст пользователя.
 *
 * Владелец платформы получает UserMerchant на каждого своего заказчика, поэтому
 * GET /user-merchant/ отдаёт ему по строке на мерчанта: свою (merchant_platform = null,
 * owned_platforms не пуст) и по одной на каждого заказчика (merchant_platform заполнен).
 * Точки заказчиков при этом приходят в общем GET /endpoint/.
 */
export function usePlatform() {
  const allPermissions = useSelector(store => store.user?.allPermissions)
  const getMy = useSelector(store => store.user?.getMy)

  return useMemo(() => {
    const permissions = Array.isArray(allPermissions) ? allPermissions : []

    const isPlatformOwner = Boolean(getMy?.is_platform_owner)
      || permissions.some(item => item?.is_platform_owner)

    // getMy отдаёт платформы напрямую, user-merchant — через мерчанта-владельца.
    const platforms = getMy?.platforms?.length
      ? getMy.platforms
      : permissions.flatMap(item => item?.owned_platforms ?? [])

    const merchantPlatformById = new Map()
    const merchantWritableById = new Map()
    permissions.forEach(item => {
      if (!item?.merchant_id) {
        return
      }
      merchantPlatformById.set(item.merchant_id, item.merchant_platform ?? null)
      // merchant_permissions приходит массивом (в userSagas берут [0]).
      // Отсутствие записи трактуем как разрешение — так же, как
      // get_writable_merchant_ids на бэке.
      const merchantPermissions = item.merchant_permissions?.[0]
      merchantWritableById.set(item.merchant_id, merchantPermissions?.can_write !== false)
    })

    return {
      isPlatformOwner,
      platforms,
      platformId: platforms?.[0]?.id ?? null,
      /** Мерчант заведён платформой, то есть это её заказчик. */
      isCustomerMerchant: (merchantId) => Boolean(merchantPlatformById.get(merchantId)),
      getMerchantPlatform: (merchantId) => merchantPlatformById.get(merchantId) ?? null,
      /** Разрешена ли запись в мерчанта (can_write из user-merchant). */
      canWriteMerchant: (merchantId) => merchantWritableById.get(merchantId) !== false,
    }
  }, [allPermissions, getMy])
}
